export const toFormData = (obj: Record<string, any>, form = new FormData(), namespace = ''): FormData =>  {
    for (const key in obj) {
        // eslint-disable-next-line
        if (!obj.hasOwnProperty(key)) continue;
        const formKey = namespace ? `${namespace}[${key}]` : key;
        const value = obj[key];

        if (value === null || value === undefined) {
            form.append(formKey, '');
        } else if (value instanceof Date) {
            form.append(formKey, value.toISOString());
        } else if (value instanceof File || value instanceof Blob) {
            form.append(formKey, value);
        } else if (typeof value === 'object' && !(value instanceof File)) {
            toFormData(value, form, formKey); // chamada recursiva para objetos aninhados
        } else {
            form.append(formKey, value.toString());
        }
    }
    return form;
}

export const defaultPaginated = {
    current_page: 1,
    data: [],
    first_page_url: '',
    from: 1,
    last_page: 1,
    last_page_url: '',
    links: [],
    next_page_url: '',
    path: '',
    per_page: 1,
    prev_page_url: '',
    to: 1,
    total: 1
}